export default function Hero() {
  return (
    <section className="relative min-h-[85vh] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://static.readdy.ai/image/3b8ad55d4ff58d61aa412f5935e39846/29f821809ccae55c0add2340fb43077a.jpeg"
          alt="TMI Logistics Fleet"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      </div>

      <div className="relative z-10 max-w-[1400px] mx-auto px-6 text-center text-white">
        <div className="mb-6">
          <span className="inline-block px-6 py-2 bg-[#8B1538]/90 backdrop-blur-sm rounded-full text-sm font-semibold tracking-wider uppercase">
            Logistics Excellence
          </span>
        </div>
        
        <h1 className="text-6xl md:text-7xl lg:text-8xl font-bold mb-6 font-['Montserrat'] leading-tight">
          TMI<br />
          <span className="text-[#8B1538]">LOGISTICS</span>
        </h1>
        
        <p className="text-xl md:text-2xl mb-12 max-w-3xl mx-auto font-['Lato'] leading-relaxed">
          Comprehensive transportation solutions for raw materials and finished chrome products
        </p>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 max-w-4xl mx-auto">
          <div className="bg-white/10 backdrop-blur-md rounded-2xl p-6 border border-white/20">
            <div className="text-4xl font-bold text-[#8B1538] mb-2">Own Fleet</div>
            <div className="text-sm uppercase tracking-wide">Company Trucks</div>
          </div>
          <div className="bg-white/10 backdrop-blur-md rounded-2xl p-6 border border-white/20">
            <div className="text-4xl font-bold text-[#8B1538] mb-2">120km</div>
            <div className="text-sm uppercase tracking-wide">Service Radius</div>
          </div>
          <div className="bg-white/10 backdrop-blur-md rounded-2xl p-6 border border-white/20">
            <div className="text-4xl font-bold text-[#8B1538] mb-2">24/7</div>
            <div className="text-sm uppercase tracking-wide">Operations</div>
          </div>
          <div className="bg-white/10 backdrop-blur-md rounded-2xl p-6 border border-white/20">
            <div className="text-4xl font-bold text-[#8B1538] mb-2">JIT</div>
            <div className="text-sm uppercase tracking-wide">Delivery Model</div>
          </div>
        </div>
      </div>
    </section>
  );
}